import { data as avgPowerData } from './data/average-power';
import * as data from './data/leak-mapper';
import { Color } from '@app/themes/colors';

const roomsColorMap = {
  A: {
    0: Color.blue,
    1: Color.green,
    2: Color.peach,
    3: Color.yellow,
    4: Color.purple,
    5: Color.lightGreen
  },
  B: {
    0: Color.purple,
    1: Color.red,
    2: Color.yellow,
    3: Color.purple,
    4: Color.blue,
    5: Color.grass
  }
};

export default class AnalyzeStore {
  public getChartConfig(overrides = {}) {
    return {
      showCrosshairs: true,
      // colorField: 'short',
      // color: ({ short }) => {
      //   const [a, b] = short;
      //   return roomsColorMap[a][b];
      // },
      // color: ['#c71e1d', '#ffca76', '#09bb9f'],
      xField: 'powerAverage',
      yField: 'powerAverage',
      appendPadding: 10,
      size: [4, 8],
      sizeField: 'powerAverage',
      shape: 'circle',
      pointStyle: { fillOpacity: 1 },
      yAxis: {
        nice: true,
        line: { style: { stroke: '#aaa' } },
        min: 0,
        label: {
          formatter: function formatter(v) {
            return v !== 0 ? v + 'kWh' : v;
          }
        }
      },
      xAxis: {
        grid: { line: { style: { stroke: '#eee' } } },
        line: { style: { stroke: '#aaa' } },
        min: 0,
        max: 1,
        label: {
          formatter: function formatter(v) {
            return v !== 0 ? v + 'kW' : v;
          }
        }
      },
      animateOption: {
        appear: 'wave-in'
      },
      // label: {},
      meta: {
        powerAverage: {
          alias: 'Average Power'
        },
        estimateKWh: {
          alias: 'Annual Consumption kWh'
        },
        ['elec/therm']: {
          alias: 'kWh elec / kWh therm'
        },
        room: {
          alias: 'Room'
        },
        short: {
          alias: 'Room'
        }
      },
      ...overrides
    };
  }

  public getAvgPowerData() {
    return avgPowerData;
  }

  public getLeakMapperData() {
    return data;
  }
}
